import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getSearchData } from "../../Apis";
import { getProjectCategory } from "../../Apis/content";

// export const GetSearchData = createAsyncThunk('GetSearchData', async ({ selected, query }, { rejectWithValue }) => {
//     try {
//         const response = await getSearchData(selected, query);
//         return response;
//     } catch (error) {
//         return rejectWithValue(error.response);
//     }
// });

// set in payload ->category_id,minPrice,maxPrice,deliveryTime,serviceDetails

export const GetSearchData = createAsyncThunk(
  "GetSearchData",
  async (
    {
      selected,
      query,
      category_id,
      serviceDetails,
      minPrice,
      maxPrice,
      deliveryTime,
    },
    { rejectWithValue }
  ) => {
    try {
      

      

     
      const response = await getSearchData(selected,query,category_id,minPrice,maxPrice,deliveryTime,serviceDetails);
      console.log("show slice responseeeeeeee------>",response);
       
      return response; 
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);
export const GetCategorySearch = createAsyncThunk(
  "GetCategorySearch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getProjectCategory();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

const searchSlice = createSlice({
  name: "search",
  initialState: {
    error: null,
    success: false,
    data: [],
  },

  reducers: {
    clearSearchSliceStatus: (state) => {
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetSearchData.pending, (state) => {
        state.error = null;
        state.success = false;
      })
      .addCase(GetSearchData.fulfilled, (state, action) => {
        state.data = action.payload.data.results;
        state.error = null;
        state.success = action.payload;
      })
      .addCase(GetSearchData.rejected, (state, action) => {
        state.error = action.payload;
        state.success = false;
      });
  },
});
export const { searchSliceStatus } = searchSlice.actions;
export default searchSlice.reducer;
